<template>
  <div>
    <div class="table-responsive" v-if="contracts.length">
      <table class="table zero-configuration-contracts" aria-label="Contracts list">
        <thead>
          <tr>
            <th>{{$t('Name')}}</th>
            <th>{{$t('Country')}}</th>
            <th>{{$t('Status')}}</th>
            <th>{{$t('Landlord')}}</th>
            <th>{{$t('Tenant')}}</th>
            <th>{{$t('Rent Start')}}</th>
            <th>{{$t('Duration')}}</th>
            <th>{{$t('Property')}}</th>
            <th>{{$t('Created At')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(contract, index) in contracts" :key="index">
            <td class="contractName capitalize">
              <span class="text-bold-500">{{
                contract.name
              }}</span>
              <br />
              <router-link
                :to="{
                  name: 'ContractSinglePage',
                  params: { uuid: contract.id },
                }"
                href="#"
                style="margin-top: 5px"
                >{{$t('View Details')}}</router-link
              >
            </td>
            <td>{{ countryName(contract.country) }}</td>
            <td class="capitalize">
              <span v-if="contract.status == 'sent'">
                <em class="bx bxs-circle info font-small-1 mr-50"></em>
                {{ contract.status }}
              </span>
              <span v-if="contract.status == 'active'">
                <em class="bx bxs-circle success font-small-1 mr-50"></em>
                {{ contract.status }}
              </span>
              <span v-if="contract.status == 'expired'">
                <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                {{ contract.status }}
              </span>
              <span v-if="contract.status == 'void'">
                <em class="bx bxs-circle light-secondary font-small-1 mr-50"></em>
                {{ contract.status }}
              </span>
            </td>
            <td>{{ contract.landlord.name ? contract.landlord.name : "-" }}</td>
            <td>
              {{ contract.tenants[0].name ? contract.tenants[0].name : "-" }}
            </td>
            <td>{{ contract.data.rentStart.split("T")[0] }}</td>
            <td>{{ contract.data.contractDuration }} months</td>
            <td>{{ contract.property.name ? contract.property.name : "-" }}</td>
            <td>{{ contract.createdAt.split("T")[0] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
export default {
  props: ["contracts"],

  methods: {
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    initDataTable() {
      setTimeout(function () {
        $(".zero-configuration-contracts").DataTable({
          scrollX: true,
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
      }, 100);
    },
  },

  mounted() {
    this.initDataTable();
  },
};
</script>

<style scoped>
.zero-configuration-contracts td,
.zero-configuration-contracts th {
  white-space: nowrap;
}
</style>